// extracted by mini-css-extract-plugin
module.exports = {"icons-section":"IconsSection_icons-section__hZI-d","icons-section__icon":"IconsSection_icons-section__icon__2ZMeI"};